import { DefaultTheme } from "styled-components";
import logoAraras from "./logo.png";
import backgroundAraras from "./background.png";

export const ararasTheme: DefaultTheme = {
  title: "araras",

  colors: {
    primary: "#080808",
    secondary: "#adb2ba",
    chatMessage: "#565b64",
  },

  images: {
    logo: logoAraras,
    background: backgroundAraras,
  },
};
